
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'RemediationModalGenerating',
  props: {
    identifier: {
      type: String,
      required: true
    }
  }
})
